(function () {
  function getQueryParam(param) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(param);
  }

  function updateHeadlines() {
    const pageParam = getQueryParam("page");
    const targetDiv = document.getElementById("dynamic-page-info");
    if (!targetDiv) return;

    let stepLabel = "";
    let titleHTML = "";
    let subtextHTML = "";

    if (pageParam === "reviewPage") {
      // FINAL STEP: No <h2> step label
      titleHTML = "Review Your Box";
      subtextHTML = "Make sure everything looks good, then let’s wrap it up at checkout.";
    } else if (pageParam === "addProductsPage1") {
      stepLabel = "The Classic Box — 9 to 14 Pounds — $169";
      titleHTML = "Build Your Box, Your Way";
      subtextHTML = "Choose how often you want it delivered.";
    } else if (pageParam === "addProductsPage2") {
      stepLabel = "The Classic Box — 9 to 14 Pounds — $169";
      titleHTML = "Choose 2 Big Cuts";
      subtextHTML = "These are bigger cuts like roasts or ribs. Great for families or leftovers.";
    } else if (pageParam === "addProductsPage3") {
      stepLabel = "The Classic Box — 9 to 14 Pounds — $169";
      titleHTML = "Choose 2 Special Cuts";
      subtextHTML = "These are top picks like steaks or chops. Great for special meals.";
    } else if (pageParam === "addProductsPage4") {
      stepLabel = "The Classic Box — 9 to 14 Pounds — $169";
      titleHTML = "Pick 2 Add-Ons";
      subtextHTML = "Finish your box with sausage, jerky, or other tasty extras.";
    } else {
      stepLabel = "Please Wait...";
      titleHTML = "Loading Your Selections";
      subtextHTML = "";
    }

    const headlineHTML = pageParam === "reviewPage"
      ? `<br>
        <h1 class="banner__title heading leading-none title-lg">
          <em class="highlighted-text inline-block not-italic relative animate" is="highlighted-text" data-style="underline">
            ${titleHTML}
          </em>
        </h1>
        <p class="banner__subheading heading uppercase leading-none tracking-widest subtitle-lg">
          ${subtextHTML}
        </p>
      `
      : `
        <h2 class="banner__title heading leading-none title-med" style="padding:5px; margin:5px;">
          ${stepLabel}
        </h2>
        <h1 class="banner__title heading leading-none title-lg" style="padding:5px; margin:5px;">
          <em class="highlighted-text inline-block not-italic relative animate" is="highlighted-text" data-style="underline">
            ${titleHTML}
          </em>
        </h1>
        <p class="banner__subheading heading uppercase leading-none tracking-widest subtitle-lg" style="padding:5px; margin:5px;">
          <strong>${subtextHTML}</strong>
        </p>
      `;

    targetDiv.innerHTML = headlineHTML;
  }

  updateHeadlines();

  let lastUrl = location.href;
  new MutationObserver(() => {
    const currentUrl = location.href;
    if (currentUrl !== lastUrl) {
      lastUrl = currentUrl;
      updateHeadlines();
    }
  }).observe(document, { subtree: true, childList: true });

  window.addEventListener("popstate", updateHeadlines);
})();
